import InvestmentFunding from "./InvestmentFunding"

export default InvestmentFunding
